import React from 'react';

/* Набор простых линейных SVG-иконок 24×24.
   Используем `currentColor` чтобы цвет управлялся через CSS (color).
   stroke-width 1.8 — современный outline-стиль. */

const base = {
    width: 24, height: 24,
    viewBox: '0 0 24 24', fill: 'none',
    stroke: 'currentColor', strokeWidth: 1.8,
    strokeLinecap: 'round', strokeLinejoin: 'round',
};

export function IconRocket(props) {
    return (
        <svg {...base} {...props}>
            <path d="M14 4c4.5 1 5.5 4 5 8-3 .5-5 .5-7-1l-3-3c-2-2-2-4-1-7 4-.5 7 .5 8 3"/>
            <circle cx="14" cy="9" r="1.4"/>
            <path d="M8 14l-3 3"/>
            <path d="M11 17l-3 3"/>
            <path d="M5 11l3-3"/>
            <path d="M5 19c0-2 1-3 3-3"/>
        </svg>
    );
}

export function IconTeacher(props) {
    return (
        <svg {...base} {...props}>
            <circle cx="12" cy="7" r="3"/>
            <path d="M5 21c0-3.5 3-6 7-6s7 2.5 7 6"/>
            <path d="M9 4l-4-2v3l4 2"/>
        </svg>
    );
}

export function IconTarget(props) {
    return (
        <svg {...base} {...props}>
            <circle cx="12" cy="12" r="9"/>
            <circle cx="12" cy="12" r="5.5"/>
            <circle cx="12" cy="12" r="2"/>
        </svg>
    );
}

export function IconDashboard(props) {
    return (
        <svg {...base} {...props}>
            <rect x="3" y="4" width="18" height="16" rx="2"/>
            <path d="M3 9h18"/>
            <path d="M9 9v11"/>
            <path d="M13 13h5"/>
            <path d="M13 17h3"/>
        </svg>
    );
}

export function IconRobot(props) {
    return (
        <svg {...base} {...props}>
            <rect x="5" y="7" width="14" height="11" rx="2"/>
            <circle cx="9" cy="12" r="1.2"/>
            <circle cx="15" cy="12" r="1.2"/>
            <path d="M10 15.5h4"/>
            <path d="M12 4v3"/>
            <circle cx="12" cy="3" r="1"/>
            <path d="M3 11v3"/>
            <path d="M21 11v3"/>
        </svg>
    );
}

export function IconRefresh(props) {
    return (
        <svg {...base} {...props}>
            <path d="M3 12a9 9 0 0 1 15.5-6.2L21 8"/>
            <path d="M21 4v4h-4"/>
            <path d="M21 12a9 9 0 0 1-15.5 6.2L3 16"/>
            <path d="M3 20v-4h4"/>
        </svg>
    );
}

export function IconGamepad(props) {
    return (
        <svg {...base} {...props}>
            <path d="M6 9h12a3 3 0 0 1 3 3v4a2 2 0 0 1-3.6 1.2l-1.6-2.2H8.2l-1.6 2.2A2 2 0 0 1 3 16v-4a3 3 0 0 1 3-3z"/>
            <path d="M8 12v3"/>
            <path d="M6.5 13.5h3"/>
            <circle cx="15.5" cy="13" r="0.8"/>
            <circle cx="17.5" cy="15" r="0.8"/>
        </svg>
    );
}

export function IconStudent(props) {
    return (
        <svg {...base} {...props}>
            <path d="M3 9l9-4 9 4-9 4-9-4z"/>
            <path d="M7 11v4c0 1.5 2.5 3 5 3s5-1.5 5-3v-4"/>
            <path d="M21 9v5"/>
        </svg>
    );
}

export function IconCheck(props) {
    return (
        <svg {...base} {...props}>
            <path d="M4 12l5 5L20 6"/>
        </svg>
    );
}

export function IconStar(props) {
    return (
        <svg {...base} fill="currentColor" stroke="none" {...props}>
            <path d="M12 2l2.9 6.6 7.1.7-5.3 4.9 1.6 7-6.3-3.7-6.3 3.7 1.6-7L2 9.3l7.1-.7L12 2z"/>
        </svg>
    );
}

export function IconArrowRight(props) {
    return (
        <svg {...base} {...props}>
            <path d="M5 12h14"/>
            <path d="M13 6l6 6-6 6"/>
        </svg>
    );
}

export function IconArrowLeft(props) {
    return (
        <svg {...base} {...props}>
            <path d="M19 12H5"/>
            <path d="M11 6l-6 6 6 6"/>
        </svg>
    );
}

export function IconBook(props) {
    return (
        <svg {...base} {...props}>
            <path d="M4 4h11a3 3 0 0 1 3 3v13H7a3 3 0 0 1-3-3V4z"/>
            <path d="M4 17a3 3 0 0 1 3-3h11"/>
        </svg>
    );
}

export function IconClock(props) {
    return (
        <svg {...base} {...props}>
            <circle cx="12" cy="12" r="9"/>
            <path d="M12 7v5l3 2"/>
        </svg>
    );
}

export function IconEye(props) {
    return (
        <svg {...base} {...props}>
            <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z"/>
            <circle cx="12" cy="12" r="3"/>
        </svg>
    );
}

export function IconPlay(props) {
    return (
        <svg {...base} fill="currentColor" stroke="none" {...props}>
            <path d="M7 5l12 7-12 7z"/>
        </svg>
    );
}

export function IconExternal(props) {
    return (
        <svg {...base} {...props}>
            <path d="M14 4h6v6"/>
            <path d="M10 14L20 4"/>
            <path d="M19 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h5"/>
        </svg>
    );
}

export function IconMail(props) {
    return (
        <svg {...base} {...props}>
            <rect x="3" y="5" width="18" height="14" rx="2"/>
            <path d="M3 7l9 6 9-6"/>
        </svg>
    );
}
